import React from "react";
import { useParams } from 'react-router-dom';
import StopPeriods from './StopPeriods';
import GracePeriods from './GracePeriods';
import { useSelector } from 'react-redux';
import { RequestState } from "../../../models/RequestState";
import { CoreModule } from "../../../models/CoreModels";
import StatusCode from "../../../util/StatusCode";
import { RootState } from "../../../store/store";


const ModulePeriods = () => {
    const { moduleId } = useParams();
    const module = useSelector<RootState, RequestState<CoreModule>>(state => state.module.moduleBasicInfo);

    if (!moduleId) {
        return;
    }

    return (
        <div className="mt-4">
            <StopPeriods
                moduleId={moduleId}
            />
            {(module.code === StatusCode.COMPLETE && module.data?.displayGracePeriod) &&
                <GracePeriods
                    moduleId={moduleId}
                />
            }
        </div>
    )
}

export default ModulePeriods;
